import { render, staticRenderFns } from "./CDialogWhistleblower.vue?vue&type=template&id=2ce54ae4&scoped=true"
import script from "./CDialogWhistleblower.vue?vue&type=script&setup=true&lang=js"
export * from "./CDialogWhistleblower.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CDialogWhistleblower.vue?vue&type=style&index=0&id=2ce54ae4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce54ae4",
  null
  
)

export default component.exports